module.exports = __webpack_public_path__ + "static/img/nuvio-black.a1245cd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nuvio-black.jpeg
// module id = 521
// module chunks = 1